import React from 'react'
import { Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import { localizeDate } from '../../../../utils/dates'
import { Payment } from '../../../../types/payment'
import {
  CardPaymentMethod,
  PaymentMethodType,
} from '../../../../types/paymentMethod'
import CreditCard from './CreditCard'

export interface PaymentSourceProps {
  payment: Payment
}

const PaymentSource = (props: PaymentSourceProps) => {
  const { createdAt, paymentMethod, sourceDescriptor } = props.payment || {}
  const { type } = paymentMethod || {}
  switch (type) {
    case PaymentMethodType.CARD:
      const { cardLast4, cardBrand, expiration } =
        paymentMethod as CardPaymentMethod

      return (
        <Grid container>
          <Grid item xs={5}>
            <CreditCard
              brand={cardBrand}
              lastFour={cardLast4}
              expiration={expiration}
            />
          </Grid>
          <Grid item xs={7}>
            <Typography
              sx={theme => ({
                fontSize: '0.75rem',
                fontWeight: 400,
                lineHeight: 1.333,
                margin: theme.spacing(0.5, 0, 0, 1.5),
                color: '#00000099',
              })}
            >
              This payment will be{' '}
              <strong>processed on {localizeDate(createdAt)}</strong>, and will
              appear on your statement as <strong>{sourceDescriptor}</strong>
            </Typography>
          </Grid>
        </Grid>
      )
    case PaymentMethodType.BANK:
      return <div>Bank Account Payment Method TBD</div>
    default:
      return <div>Invalid Payment Method Type</div>
  }
}

export default PaymentSource
